import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import AuthForm from '~/src/components/AuthForm';
import { createSendVasGA } from '~/src/helpers/eventsForDataLayer';

import { Advantage } from './Advantage';
import { advantageData } from './advantage-data/data';
import AuthControl from './AuthControl';
import * as ST from './styled';
import { Tariff } from './Tariff';
import { tariffData } from './tariff-data/data';

const sendWatchVasGA = createSendVasGA('watch-everywhere:');

class WatchEverywhere extends Component {
    static defaultProps = {
        isAuth: false,
    };

    static propTypes = {
        isAuth: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.tariffRef = React.createRef();
        this.state = {
            isOpen: false,
            popupId: null,
        };
    }

    onScrollToTariff = () => {
        this.tariffRef.current.scrollIntoView();
    }

    togglePopup = (id, name) => {
        sendWatchVasGA('click details btn', name);
        this.setState((state) => ({
            isOpen: !state.isOpen,
            popupId: id,
        }));
    }

    renderPopupContent = () => {
        const { popupId } = this.state;

        if (popupId === 1) {
            return (
                <ST.PopupWrap data-test='marketPopup' hasBackColor={true}>
                    <ST.PopupTitle>Подключите за 0 р/мес</ST.PopupTitle>
                    <ST.PopupText>
                        Просто скачайте приложение в App Store или Google Play и смотрите ТВ где удобно.
                    </ST.PopupText>
                    <ST.PopupRow>
                        <ST.StoreButton data-test='linkApple' store='MovixAppStore'/>
                        <ST.StoreButton store='MovixGooglePlay'/>
                    </ST.PopupRow>
                </ST.PopupWrap>
            );
        }

        return (
            <AuthForm/>
        );
    }

    renderAdvantageList = () => {
        return (
            <ST.CardList>
                {advantageData.map(item => (
                    <ST.CardItem key={item.id}>
                        <Advantage item={item}/>
                    </ST.CardItem>
                ))}
            </ST.CardList>
        );
    }

    renderTariffList = () => {
        const { isAuth } = this.props;
        return (
            <ST.CardList>
                {tariffData.map(item => (
                    <ST.TariffCardItem key={item.id}>
                        <Tariff
                            item={item}
                            btnClick={id => this.togglePopup(id, item.name)}
                            isAuth={isAuth}
                        />
                    </ST.TariffCardItem>
                ))}
            </ST.CardList>
        );
    }

    render() {
        const { isAuth } = this.props;

        return (
            <ST.WatchEverywhere>
                <ST.TopSection>
                    <ST.ContentWrap>
                        <ST.TopDescription>
                            <ST.PageTitle>Смотри везде</ST.PageTitle>
                            <ST.Text>
                                <p>
                                    Если у&nbsp;вас дома много телевизоров, не&nbsp;обязательно подключать ТВ-тариф на&nbsp;каждый.
                                    Сэкономьте на&nbsp;абонентской плате: подключите к&nbsp;тарифу один телевизор, а&nbsp;остальные
                                    телевизоры и&nbsp;другие гаджеты к&nbsp;&laquo;Смотри везде&raquo;. И&nbsp;ТВ-каналы,
                                    фильмы и&nbsp;подписки из&nbsp;тарифа можно будет смотреть на&nbsp;всех домашних экранах.
                                </p>
                                <p>
                                    *Чтобы услуга работала на&nbsp;обычном телевизоре нужна ТВ-приставка.
                                    На&nbsp;smart-телевизоре&nbsp;&mdash; приложение для Smart TV. На&nbsp;смартфоне, планшете или
                                    ноутбуке смотрите бесплатно через приложение &laquo;Дом.ру MOVIX&raquo;.
                                </p>
                            </ST.Text>

                            {
                                !isAuth &&
                                <ST.TopButton
                                    type={btnTypes.ACCENT}
                                    data-test='watchEverywhere'
                                    onClick={this.onScrollToTariff}
                                >
                                    Подключить
                                </ST.TopButton>
                            }
                        </ST.TopDescription>
                        <ST.ImageWrap>
                            <ST.Img src='/static/images/domru-tv/watch_head.png' alt=''/>
                        </ST.ImageWrap>
                    </ST.ContentWrap>
                </ST.TopSection>

                {
                    isAuth &&
                    <ST.Section>
                        <ST.ContentWrap>
                            <AuthControl/>
                        </ST.ContentWrap>
                    </ST.Section>
                }

                <ST.Section>
                    <ST.ContentWrap>
                        <ST.SectionTitle ref={this.tariffRef}>Сравнить тарифы «Смотри везде»</ST.SectionTitle>
                    </ST.ContentWrap>
                    <ST.ContentWrap>
                        {this.renderTariffList()}
                    </ST.ContentWrap>
                </ST.Section>

                <ST.Section>
                    <ST.ContentWrap>
                        {this.renderAdvantageList()}
                    </ST.ContentWrap>
                </ST.Section>

                <DefaultPopup
                    isOpen={this.state.isOpen}
                    backgroundColor={'#fff'}
                    closeColor={'#000'}
                    onClose={this.togglePopup}
                >
                    {this.renderPopupContent()}
                </DefaultPopup>
            </ST.WatchEverywhere>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps)(WatchEverywhere);
